import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { AlertService } from '@src/core/services';
import { CordovaService } from '@src/app/modules/cordova';
import { InternalMessengerService } from '@src/app/modules/internal-messenger';

@Component({
  selector: 'app-testing-control',
  templateUrl: './testing-control.component.html',
  styleUrls: ['./testing-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestingControlComponent {
  private readonly clipboard = inject(Clipboard);
  private readonly alertService = inject(AlertService);
  private readonly cordovaService = inject(CordovaService);
  private readonly messengerService = inject(InternalMessengerService);

  get connectionId() {
    return this.messengerService.connectionId;
  }

  readonly deviceId$ = this.cordovaService.fcmToken$;

  connectionIdCopyToClipboard(text?: string) {
    if (text && this.clipboard.copy(text)) {
      this.alertService.success('id соединения мессенджера скопирован');
    }
  }

  deviceIdCopyToClipboard(text?: string) {
    if (text && this.clipboard.copy(text)) {
      this.alertService.success('id устройства скопирован');
    }
  }

  registerDevice(deviceId: string) {
    this.cordovaService.registerDevice(deviceId);
  }
}
